@if (profile$ | async; as profile) {
    @if (profileFields$ | async; as profileFields) {
        @if (profileFields.length > 0) {
            <fieldset [id]="profile.Id" class="sh-form-fieldset">
                <legend class="sh-form-fieldset__legend">{{ profile.Name }}</legend>
                @for (profileField of profileFields$ | async; track profileField) {
                    @if (profileField.FieldDefinition) {
                        <sh-generic-field
                            [profileField]="profileField"
                            [formGroup]="formGroup"
                            [records]="records"
                            [recordInheritance]="recordInheritance"
                            [aiProfile]="aiProfile"
                            [isBatchEdit]="isBatchEdit"
                            [canEditStandard]="canEditStandard$ | async"
                            [canEditAdvanced]="canEditAdvanced$ | async"
                            [style.display]="isVisuallyHidden(profileField) ? 'none' : 'inherit'"
                            [autocompleteFct]="getAutocompleteFct(profileField)"
                            [subFieldAutocompleteFcts]="getSubFieldAutocompleteFcts(profileField)"
                            [nestedIndex]="0"
                        >
                        </sh-generic-field>
                    } @else {
                        <dt class="sh-description-list__term">{{ profileField.DisplayLabel }}</dt>
                        <dd class="sh-description-list__details">
                            {{ "form.error.fielddefinition-not-found" | translate: { id: profileField.FieldDefinitionId } }}
                        </dd>
                    }
                }
            </fieldset>
        }
    }
}
